import * as types from './mutation-types'

export default {
  [types.SET_FORMS] (state, obj) {
    state.forms = obj
  },
  [types.SET_FORM] (state, obj) {
    state.form = obj
  },
  [types.SET_STEPS] (state, steps) {
    state.steps = steps
  },
  [types.ADD_STEP] (state, step) {
    state.steps.push(step)
  },
  [types.UPDATE_STEP] (state, { index, step }) {
    if (index !== -1) {
      state.steps.splice(index, 1, step)
    }
  },
  [types.REMOVE_STEP] (state, index) {
    state.steps.splice(index, 1)
  },
  [types.SET_FIELDS] (state, fields) {
    state.fields = fields
  },
  [types.ADD_FIELD] (state, field) {
    state.fields.push(field)
  },
  [types.UPDATE_FIELD] (state, { index, field }) {
    if (index !== -1) {
      state.fields.splice(index, 1, field)
    }
  },
  [types.REMOVE_FIELD] (state, index) {
    state.fields.splice(index, 1)
  },
  [types.SET_FIELD_TYPES] (state, fieldTypes) {
    state.fieldTypes = fieldTypes
  },
  [types.SET_FIELD_TYPES_GROUPED] (state, grouped) {
    state.fieldTypesGrouped = grouped
  },
  [types.SET_SELECTED_FIELD] (state, field) {
    state.selectedField = field
  },
  [types.SET_SELECTED_STEP] (state, step) {
    state.selectedStep = step
  },
  [types.SET_DIRTY] (state, value) {
    state.isDirty = value
  },
  [types.SET_LOADING] (state, value) {
    state.isLoading = value
  },
  [types.RESET_BUILDER] (state) {
    state.form = null
    state.steps = []
    state.fields = []
    state.selectedField = null
    state.selectedStep = null
    state.isDirty = false
  }
}
